// removed by extract-text-webpack-plugin
module.exports = {"selected-addresses":"FPyb4AeCBZPFd2xVDeG9g"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressForm/style.scss
// module id = 928
// module chunks = 0